import React from 'react';
import styled from 'styled-components';
import {
    Window,
    WindowContent,
    WindowHeader,
    Button,
    Toolbar,
    Panel
} from 'react95';
  
const Wrapper = styled.div`
  background: teal;
  position: absolute;
  left: ${window.innerWidth * .01}%;
  top: 10%;
  .window-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .close-icon {
    display: inline-block;
    width: 16px;
    height: 16px;
    margin-left: -1px;
    margin-top: -1px;
    transform: rotateZ(45deg);
    position: relative;
    &:before,
    &:after {
      content: '';
      position: absolute;
      background: ___CSS_0___;
    }
    &:before {
      height: 100%;
      width: 3px;
      left: 50%;
      transform: translateX(-50%);
    }
    &:after {
      height: 3px;
      width: 100%;
      left: 0px;
      top: 50%;
      transform: translateY(-50%);
    }
  }
  .window {
    width: 400px;
    min-height: 200px;
  }
  .window:nth-child(2) {
    margin: 2rem;
  }
  .footer {
    display: block;
    margin: 0.25rem;
    height: 31px;
    line-height: 31px;
    padding-left: 0.25rem;
  }
`;

const Internet = (props) => {
    return (
    <Wrapper>
        <Window resizable className='window'>
        <WindowHeader className='window-header'>
            <span>The Internet</span>
            <Button onClick={() => props.visibleComp()}>
                <span className='close-icon'>X</span>
            </Button>
        </WindowHeader>
        <Toolbar>
            <Button variant='menu' size='sm'>
            File
            </Button>
            <Button variant='menu' size='sm'>
            Edit
            </Button>
            <Button variant='menu' size='sm' disabled>
            Save
            </Button>
        </Toolbar>
        <WindowContent>
            <p>
            Gatos online vs JavaScript
            </p>
            <iframe width="100%" height="300" src="https://www.youtube.com/embed/uHKfrz65KSU" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>

        </WindowContent>
        <Panel variant='well' className='footer'>
            👾🤖 coding is awesome XDD
        </Panel>
        </Window>
    </Wrapper >
    );
};

export default Internet;
